import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "paidDateField", "paidDateInfo" ]
  static values = { paid: Boolean }

  connect() {
    this.refresh()
  }

  refresh() {
    const paidSelected = this.statusSelect?.value === "paid"

    if (this.hasPaidDateFieldTarget) {
      this.toggle(this.paidDateFieldTarget, paidSelected && !this.paidValue)
    }

    if (this.hasPaidDateInfoTarget) {
      this.toggle(this.paidDateInfoTarget, paidSelected && this.paidValue)
    }
  }

  get statusSelect() {
    return this.element.querySelector("select[name='invoice[status]']")
  }

  toggle(element, visible) {
    element.hidden = !visible
    element.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible
    })
  }
}
